var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('allmeetings')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0e2c6a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/AllMeetings_minbolig.vue
// module id = 914
// module chunks = 4